import {
  getFormValue,
  setMessageVisibility,
  setQuestionVisibility,
  clearFieldValue,
  changeFieldValue,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum, MessagesEnum } from 'app/shared/enums';
import { DictionaryEntry } from 'app/services/dict.service';
import store from 'app/store';
import { FormsConfigActions } from 'app/store/data/formsConfig';

export const travelDestination = {
  changeTravelDestination(initialRun: boolean) {
    const travelDestinationCountryCodes = getFormValue(
      FieldsEnum.TravelDestinationCountryCodes,
      FormsEnum.TravelForm
    );

    const isPolandSelected = travelDestinationCountryCodes.some(
      (destination: DictionaryEntry['key']) => destination === 'PL'
    );

    setQuestionVisibility({
      key: FieldsEnum.TravelDestinationResultsForPoland,
      visible: isPolandSelected,
      formName: FormsEnum.TravelForm,
    });

    setMessageVisibility({
      key: MessagesEnum.TravelOver99DestinationsError,
      visible: travelDestinationCountryCodes.length > 99,
      formName: FormsEnum.TravelForm,
    });

    const state = store.getState();

    const isUSSelected = travelDestinationCountryCodes.some(
      (destination: DictionaryEntry['key']) => destination === 'US'
    );

    const travelFormConfig = state.formsConfig[FormsEnum.TravelForm];
    const currentDictionary =
      travelFormConfig?.dictionaries?.['travel.transportForms_dictionary'] ||
      [];

    let newDictionary = [...currentDictionary];
    if (isUSSelected) {
      newDictionary = currentDictionary.filter(
        (entry: DictionaryEntry) => entry.key !== 'own_car'
      );

      const currentTransportForms = getFormValue(
        FieldsEnum.TravelTransportForms,
        FormsEnum.TravelForm
      );

      if (
        Array.isArray(currentTransportForms) &&
        currentTransportForms.includes('own_car')
      ) {
        const updatedTransportForms = currentTransportForms.filter(
          (transport: string) => transport !== 'own_car'
        );
        if (updatedTransportForms.length > 0) {
          changeFieldValue(
            FieldsEnum.TravelTransportForms,
            updatedTransportForms,
            FormsEnum.TravelForm
          );
        } else {
          clearFieldValue(
            FieldsEnum.TravelTransportForms,
            FormsEnum.TravelForm
          );
        }
      }
    } else {
      const hasOwnCar = currentDictionary.some(
        (entry: DictionaryEntry) => entry.key === 'own_car'
      );

      if (!hasOwnCar) {
        newDictionary = [
          {
            key: 'own_car',
            value: 'Własny samochód',
          },
          ...currentDictionary,
        ];
      }
    }

    store.dispatch(
      FormsConfigActions.setDictionaryAction({
        dictionaryKey: 'travel.transportForms_dictionary',
        dictionary: newDictionary,
        formName: FormsEnum.TravelForm,
      })
    );
  },
};
